/**
 * Page-specific background pattern utilities
 * Maps routes to CSS class names for subtle background patterns
 */

export type PageRoute = 
	| '/'
	| '/services'
	| '/gallery'
	| '/testimonials'
	| '/contact'
	| '/faq'
	| '/areas-covered'
	| '/thank-you'
	| '*';

/**
 * Maps page routes to their corresponding background pattern CSS class names
 */
export const PAGE_BACKGROUND_MAP: Record<PageRoute, string> = {
	'/': 'page-bg-home',
	'/services': 'page-bg-services',
	'/gallery': 'page-bg-gallery',
	'/testimonials': 'page-bg-testimonials',
	'/contact': 'page-bg-contact',
	'/faq': 'page-bg-faq',
	'/areas-covered': 'page-bg-areas',
	'/thank-you': 'page-bg-thankyou',
	'*': 'page-bg-notfound',
};

/**
 * Gets the background pattern class name for a given route path
 * @param pathname - The current route pathname
 * @returns The CSS class name for the background pattern
 */
export function getPageBackgroundClass(pathname: string): string {
	// Normalize pathname
	const normalizedPath = pathname === '/' ? '/' : pathname.toLowerCase();
	
	// Check for exact match first
	if (normalizedPath in PAGE_BACKGROUND_MAP) {
		return PAGE_BACKGROUND_MAP[normalizedPath as PageRoute];
	}
	
	// Check for partial matches (e.g., /areas-covered matches /areas-covered)
	for (const [route, className] of Object.entries(PAGE_BACKGROUND_MAP)) {
		if (normalizedPath.startsWith(route) && route !== '*') {
			return className;
		}
	}
	
	// Default to not found pattern
	return PAGE_BACKGROUND_MAP['*'];
}
